import React from "react";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { uploadAudio } from "../store/actions/uploadMediaAction";
import { jwplayerRequest, uploadFileToLink } from "../services/jwplayer";
import { addAudioTrack, deleteAudioTrack, getAudioTracks } from "../services/mediaTracks";
import TrackUploader from "./TrackUploader";

const AUDIO_LANGUAGES = [
  { value: "English en", label: "English (en)" },
  { value: "Espanish es", label: "Espanish (es)" },
];

const UploadAudio = ({
  media_id,
  mediaObjId,
  disableProp,
  generalContentObject,
  addURL,
  deleteURL,
  getURL,
}) => {
  const dispatch = useDispatch();

  // console.log("generalContentObject", generalContentObject);
  // console.log("mediaObjId", mediaObjId);
  const [audioTracksList, setAudioTracksList] = useState([]);
  useEffect(() => {
    setIsDisabled(disableProp);
    setTimeout(() => {
      getAudioTracks(getURL, mediaObjId).then((result) => {
        setAudioTracksList(result.audio_tracks);
      });
    }, 2000);
  }, [disableProp, generalContentObject, getURL, mediaObjId]);
  const [isDisabled, setIsDisabled] = useState(disableProp);

  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState("defaultaudio");
  // for language selection
  const [langSelect, setlangSelect] = useState(false);
  const [showError, setShowError] = useState(false);
  const [audioFile, setAudioFile] = useState(null);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [disableCancelButton, setDisableCancelButton] = useState(false);

  const inpContainer = useRef(null);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);

    setlangSelect(true);
  };

  const handleFileChange = (e) => {
    setDisableSubmitButton(false);
    const file = e.target.files[0];
    const allowedExtensions = ["aac"];

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        e.target.value = "";
        setDisableSubmitButton(true);
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 3000);

        return;
      }

      setAudioFile(file);
    }

    // console.log(selectedAudioFile);
  };
  const handleCancel = () => {
    setSelectedOption("defaultaudio");
    setAudioFile(null);
    setlangSelect(false);
    setDisableSubmitButton(false);
  };

  const uploadAudioTrack = async () => {
    // console.log("media id prop: ", media_id);
    // console.log("audioFile.length > 0", audioFile !== null);
    if (audioFile !== null) {
      setDisableSubmitButton(true);
      setDisableCancelButton(true);
      toast.success("Uploading Audio File!", {
        progressStyle: { background: "var(--iq-primary)" },
      });
      var jwData = {
        upload: {
          mime_type: "audio/aac",
          method: "direct",
        },

        metadata: {
          name: selectedOption.split(" ")[0],
          type: "language",
          language: selectedOption.split(" ")[0].toLowerCase(),
          language_code: selectedOption.split(" ")[1],
        },
      };

      var data = {
        body: jwData,
        url: `/media/${media_id}/originals/`,
        method: "post",
        jw_tag: false,
      };
      console.log("jw data", data);
      await jwplayerRequest(data)
        .then(async (onJwSuccess) => {
          // console.log("jw success: ", onJwSuccess);

          var original_id = onJwSuccess.data.data.id;

          var meta_data = onJwSuccess.data.data.metadata;

          // console.log("meta data: ", meta_data);

          var apiData = {
            original_id: original_id,
            name: meta_data.name,
            language: meta_data.language,
            language_code: meta_data.language_code,
            type: meta_data.type,
          };
          console.log("apiData", apiData);
          // Wait for the upload: the track is only saved when the file is sent.
          var fileUploaded = await uploadFileToLink(
            // audioUploadLink,
            onJwSuccess.data.data.upload_link,
            audioFile,
            "audio/aac"
          );
          // console.log(
          //   "url of add audio",
          //   `${BASE_URL}/api/audio/${addURL}/${mediaObjId}`
          // );
          if (!fileUploaded) {
            // console.log("audio file uploaded:");
            toast.error("Please Select Audio File!", {
              progressStyle: { background: "var(--iq-primary)" },
            });
          } else {
            await addAudioTrack(addURL, mediaObjId, apiData)
              .then((onAudioCreate) => {
                // console.log("audio created: ", onAudioCreate.data);
                dispatch(uploadAudio(onAudioCreate));
                toast.success("Audio File Submitted Successfully!", {
                  progressStyle: { background: "var(--iq-primary)" },
                });
                setSelectedOption("defaultaudio");
                setlangSelect(false);
                setAudioFile(null);
                setDisableSubmitButton(false);
                setDisableCancelButton(false);
                getAudioTracks(getURL, mediaObjId).then((result) => {
                  setAudioTracksList(result.audio_tracks);
                });
              })
              .catch((onAudioCreateError) => {
                // console.log("on audio create error: ", onAudioCreateError);
                toast.error("Please Select Audio File!", {
                  progressStyle: { background: "var(--iq-primary)" },
                });
                setDisableSubmitButton(false);
                setDisableCancelButton(false);
              });
          }
        })
        .catch((onJwError) => {
          console.log("on jw error: ", onJwError);
          toast.error("Please Select Audio File!", {
            progressStyle: { background: "var(--iq-primary)" },
          });
        });
    } else {
      toast.error("Please Select Audio File!", {
        progressStyle: { background: "var(--iq-primary)" },
      });
    }
  };

  const handleDelete = async (audioTrack_id) => {
    // console.log("subtitle_id>>>", audioTrack_id);
    try {
      await deleteAudioTrack(deleteURL, mediaObjId, audioTrack_id);
      // console.log("deleted audio tracks>>>>");
      toast.success("Audio Track Deleted Successfully!", {
        progressStyle: { background: "var(--iq-primary)" },
      });

      getAudioTracks(getURL, mediaObjId).then((result) => {
        setAudioTracksList(result.audio_tracks);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <TrackUploader
      id="audio"
      chooseLabel={t("choose audio files")}
      languages={AUDIO_LANGUAGES}
      language={selectedOption}
      onLanguageChange={handleOptionChange}
      formOpen={langSelect}
      accept=".aac"
      extensions="AAC"
      file={audioFile}
      onFileChange={handleFileChange}
      inputRef={inpContainer}
      showError={showError}
      disabled={isDisabled}
      disableSubmit={disableSubmitButton}
      disableCancel={disableCancelButton}
      onSubmit={uploadAudioTrack}
      onCancel={handleCancel}
      tracks={audioTracksList}
      onDelete={handleDelete}
      deleteQuestion={(language) =>
        t("Delete the {{language}} audio track?", { language })
      }
    />
  );
};

export default React.memo(UploadAudio);
